import React from 'react';
import InputField from '../../../../../../component/form/FormInput';
import { getCurrentDate } from '../../../../../../utils/dateUtils';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import PageLoader from '../../../../../../component/PageLoader';

export default function GeneralProducts({
	generalForm,
	setGeneralForm,
	error,
	setError,
	setIsEdit,
	productLoader,
}) {
	const dayTypeList = [
		{ key: 0, value: 'Days' },
		{ key: 1, value: 'Weeks' },
		{ key: 2, value: 'Months' },
	];
	const monthsCountList = Array.from({ length: 12 }, (_, index) => {
		const monthNumber = index + 1;
		const formattedMonth = String(monthNumber).padStart(2, '0');

		return {
			key: `${monthNumber}m`,
			month: monthNumber,
			value: `${formattedMonth} Month${monthNumber > 1 ? 's' : ''}`,
		};
	});

	const handleFormData = (key, value) => {
		setGeneralForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	const handleCheckboxChange = (key, checked) => {
		handleFormData(key, checked);
	};

	return (
		<div className="general-products-container">
			{productLoader.isLoader && productLoader.isGetData ? (
				<PageLoader />
			) : (
				generalForm && (
					<div className="p-3">
						<div className="row align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Enable Inventory Tracking</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enabled_inventory_tracking}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData(
												'enabled_inventory_tracking',
												!generalForm.enabled_inventory_tracking,
											)
										}
									/>
								</div>
							</div>
						</div>
						{generalForm.enabled_inventory_tracking && (
							<div className="d-flex align-items-center my-2">
								<div className="col-4 text-sm font-medium text-start">Inventory Start Date</div>
								<div className="col-8 my-2">
									<InputField
										label=""
										placeholder="Date"
										type="date"
										required={false}
										value={generalForm.inventory_start_date}
										onBlur={(e) => {
											var value = e.target.value;
											const newError = { ...error };
											var date = new Date(value);
											var currentDate = new Date();
											currentDate.setDate(currentDate.getDate() + 1);
											let year = date.getFullYear().toString();
											if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
												setGeneralForm((prev) => ({
													...prev,
													inventory_start_date: value,
												}));
											} else if (
												year.length === 4 &&
												new Date(value) > currentDate.setHours(0, 0, 0, 0)
											) {
												newError.inventory_start_date =
													'Inventory start date cannot be in the future';
												setError(newError);
												setGeneralForm((prev) => ({
													...prev,
													inventory_start_date: value,
												}));
											} else {
												setGeneralForm((prev) => ({
													...prev,
													inventory_start_date: value,
												}));
												delete newError.inventory_start_date;
												setError(newError);
											}
										}}
										onChange={(value) => {
											const newError = { ...error };
											var date = new Date(value);
											var currentDate = new Date();
											currentDate.setDate(currentDate.getDate() + 1);
											let year = date.getFullYear().toString();
											if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
												setGeneralForm((prev) => ({
													...prev,
													inventory_start_date: value,
												}));
											} else if (
												year.length === 4 &&
												new Date(value) > currentDate.setHours(0, 0, 0, 0)
											) {
												newError.inventory_start_date =
													'Inventory start date cannot be in the future';
												setError(newError);
												setGeneralForm((prev) => ({
													...prev,
													inventory_start_date: value,
												}));
											} else {
												setGeneralForm((prev) => ({
													...prev,
													inventory_start_date: value,
												}));
												delete newError.inventory_start_date;
												setError(newError);
											}
										}}
										max={getCurrentDate()}
										error={error?.inventory_start_date}
									/>
								</div>
							</div>
						)}
						<div className="row align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Enable Auto Purchase Order</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enable_auto_purchase_order}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData(
												'enable_auto_purchase_order',
												!generalForm.enable_auto_purchase_order,
											)
										}
									/>
								</div>
							</div>
						</div>
						<div className="row align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Enable Low stock alert</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enable_low_stock_alert}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData('enable_low_stock_alert', !generalForm.enable_low_stock_alert)
										}
									/>
								</div>
							</div>
						</div>
						<div className="d-flex align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Near Expiry Alert</div>
							<div className="col-8 my-2">
								<div className="col-12 col-xl-4">
									<InputSelect
										options={monthsCountList}
										label=""
										placeholder="No of months"
										required={false}
										value={generalForm?.near_expiry_threshold}
										returnInputValue={false}
										onChange={(value) => { }}
										onSelect={(option) => {
											handleFormData('near_expiry_threshold', option.key);
										}}
										error={error.near_expiry_threshold}
										autoFocus={false}
										className="labelClass"
									/>
								</div>
							</div>
						</div>
						<div className="row align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Enable Composite Items</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enable_composite_items}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData('enable_composite_items', !generalForm.enable_composite_items)
										}
									/>
								</div>
							</div>
						</div>
						<div className="row align-items-center my-2">
							<div className="col-4">
								<div className="text-sm font-medium text-start">
									Prevent stock from going below zero
								</div>
								<div
									className="fs-5 font-small text-start"
									style={{ color: '#555B67' }}
								>
									Show an “Out of Stock” warning
								</div>
							</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enabled_out_of_stock_alert}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData(
												'enabled_out_of_stock_alert',
												!generalForm.enabled_out_of_stock_alert,
											)
										}
									/>
								</div>
							</div>
						</div>
						<div className="row align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Enable Batch Tracking</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enable_batch_tracking}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData('enable_batch_tracking', !generalForm.enable_batch_tracking)
										}
									/>
								</div>
							</div>
						</div>
						<div className="row align-items-center my-2">
							<div className="col-4">
								<div className="text-sm font-medium text-start">
									Automatically Disable Expired & Out-of-Stock Batches
								</div>

								<div
									className="fs-5 font-small text-start"
									style={{ color: '#555B67' }}
								>
									Expired and out-of-stock batches will be
									automatically disabled when this setting is enabled.
								</div>
							</div>

							<div className="col-8 my-2">
								<div className="form-check">
									<input
										className="form-check-input"
										type="checkbox"
										id="autoDisableExpiredOutOfStockBatches"
										checked={
											!!generalForm.auto_disable_expired_out_of_stock_batches
										}
										onChange={(e) =>
											handleCheckboxChange(
												'auto_disable_expired_out_of_stock_batches',
												e.target.checked,
											)
										}
									/>
								</div>
							</div>
						</div>
						<div className="row align-items-center my-2">
							<div className="col-4 text-sm font-medium text-start">Auto-Restock</div>
							<div className="col-8 my-2">
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={generalForm.enable_auto_restock}
										id="flexCheckDefault"
										onChange={(e) =>
											handleFormData('enable_auto_restock', !generalForm.enable_auto_restock)
										}
									/>
								</div>
							</div>
						</div>
						{generalForm.enable_auto_restock && (
							<div className="row align-items-center">
								<div className="col-4 text-sm font-medium text-start">Frequency</div>
								<div className="d-flex gap-4 col-8 align-items-center">
									<div className="col-2">
										<InputField
											label=""
											placeholder="Numbers"
											type="text"
											required={false}
											error={error.auto_restock_frequency}
											value={generalForm?.auto_restock_frequency}
											onChange={(valueData) => {
												var newError = { ...error };
												var value = valueData?.replace(/[^0-9]/g, '');
												handleFormData('auto_restock_frequency', value);
												if (value === '' || Number(value) < 1) {
													newError.auto_restock_frequency =
														'Please enter greater than 0 in the field';
												} else {
													delete newError.auto_restock_frequency;
												}
												setError(newError);
											}}
										/>
									</div>
									<div className="col-4">
										<InputSelect
											options={dayTypeList}
											label=""
											placeholder="select days"
											required={false}
											value={generalForm?.auto_restock_interval_type}
											returnInputValue={false}
											onChange={(value) => {
												var newError = { ...error };
												if (value === '') {
													handleFormData('auto_restock_interval_type', '');
													newError.auto_restock_interval_type =
														'Please select valid  auto restock interval type from the list';
												} else {
													delete newError.auto_restock_interval_type;
												}
												setError(newError);
											}}
											onSelect={(option) => {
												handleFormData('auto_restock_interval_type', option.value);
												if (option.value) {
													var newError = { ...error };
													delete newError.auto_restock_interval_type;
													setError(newError);
												}
											}}
											error={error.auto_restock_interval_type}
											autoFocus={false}
											className="labelClass"
										/>
									</div>
								</div>
							</div>
						)}

						<div className="row align-items-center my-2">
							<div className="col-4">
								<div className="text-sm font-medium text-start">
									Include Yet to Receive and In Transit stock along with available for sale to
									generate auto-restock tasks
								</div>
								<div
									className="fs-5 font-small text-start"
									style={{ color: '#555B67' }}
								>
									By enabling this preference, the quantity to restock will include yet to receive
									and in transit stock along with available for sale while generating auto-restock
									tasks.
								</div>
							</div>
							<div className="row align-items-center my-2">
								<div className="col-4">
									<div className="text-sm font-medium text-start">
										Mark expired products as inactive
									</div>
									<div
										className="fs-5 font-small text-start"
										style={{ color: '#555B67' }}
									>
										Automatically mark a product inactive when all batches associated with the product are expired.
									</div>
								</div>
								<div className="col-8 my-2">
									<div className="form-check">
										<input
											className="form-check-input"
											type="checkbox"
											checked={generalForm?.mark_expired_products_as_inactive ?? true}
											id="flexCheckMarkExpired"
											onChange={(e) =>
												handleFormData(
													'mark_expired_products_as_inactive',
													e.target.checked,
												)
											}
										/>
									</div>
								</div>
							</div>
							<div className="row align-items-center my-2">
								<div className="col-4">
									<div className="text-sm font-medium text-start">
										Mark out-of-stock products as inactive
									</div>
									<div
										className="fs-5 font-small text-start"
										style={{ color: '#555B67' }}
									>
										Automatically mark a product inactive when the total available quantity across all batches reaches zero.
									</div>
								</div>
								<div className="col-8 my-2">
									<div className="form-check">
										<input
											className="form-check-input"
											type="checkbox"
											checked={generalForm?.mark_out_of_stock_products_as_inactive ?? true}
											id="flexCheckMarkOutOfStock"
											onChange={(e) =>
												handleFormData(
													'mark_out_of_stock_products_as_inactive',
													e.target.checked,
												)
											}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				)
			)}
		</div>
	);
}
